module.exports = __webpack_public_path__ + "static/img/bristows.c28e01a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logos/home-page-logos/bristows.png
// module id = 0+j6
// module chunks = 0